export default "__VITE_PUBLIC_ASSET__5b76d391__"